export default "__VITE_ASSET__CACXxKaM__"